'use strict';

class Footer {
	constructor(){
		this.target = document.querySelector('.footer');
	}
	render(){
		// this.headerHidden();
	}

	headerHidden(){
		const observer = new IntersectionObserver((entries)=>{
			entries.forEach((entry)=>{
				if( entry.isIntersecting ) {
					$('.header').addClass('is-hidden');
					// observer.unobserve(this.target);
				}else{
					$('.header').removeClass('is-hidden');
				}
			});
		}, {
			rootMargin: '0px 0px -80% 0px'
		});
		observer.observe(this.target);
	}
}

export default Footer;
